import React from "react";
import { useRouteError } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import AppLogo from "../../assets/audere-africa-logo.png";
import { createStyleSheet, globalStyles } from "../utils/styles";

const Error: React.FC = () => {
  const error = useRouteError() as Error;

  return (
    <Box sx={styles.mainPanel}>
      <img
        src={AppLogo}
        alt="App Logo"
        style={{ maxWidth: 300 }}
      />
      <Box sx={styles.textBox}>
        <Typography variant='h3'>{error.cause as string}</Typography>
        <Typography>{error.message}</Typography>
      </Box>
    </Box>
  );
};

const styles = createStyleSheet({
  mainPanel: {
    ...globalStyles.pageContainerColumn,
    justifyContent: "center",
    alignItems: "center",
    gap: "30px",
    margin: "0px 50px"
  },
  textBox: {
    ...globalStyles.flexColumn,
    alignItems: "center",
    textAlign: "center"
  },
});

export default Error;
